import { JSONable } from '@irian-ro/abstract-resource';
import { AbstractContactVO } from './abstract-contact-vo.model';
import { Maybe } from '@irian-ro/util-functions';

export class GroupedAbstractContactListVO extends JSONable {
  entityUuid: Maybe<string> | undefined = undefined;
  abstractContactVOs: Maybe<AbstractContactVO[]> | undefined = undefined;

}
